import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Homepage } from './homepage/homepage';
import { Features } from './features/features';
import { Contact } from './contact/contact';

const routes: Routes = [
  { path: '', component: Homepage, pathMatch: 'full', data: {}},
  { path: 'features', component: Features, pathMatch: 'full', data: {}},
  { path: 'contact', component: Contact, pathMatch: 'full', data: {}},
  {path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled', scrollOffset: [0, 64] })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
